import React from "react";
import styled from "styled-components";
import Header from "../header/header";
import StaticFooter from "../footer/footer-static";

const Container = styled.div`
	width: 90%;
	max-width: 1200px;
	margin: auto;
	min-height: 50vh;
	@media (min-width: 768px) {
		width: 80%;
	}
`;

const Title = styled.h2`
	font-weight: bold;
	font-size: 32px;
	margin-top: 32px;
	margin-bottom: 8px;
`;

const p = styled.p`
	font-weight: normal;
	font-size: 17px;
	margin: 0;
	margin-bottom: 32px;
`;

const CladdingSpraying = () => (
	<div>
		<Container>
			<Header />
			<a href="/" alt="home">
				&#8592; Back to Home
			</a>
			<Title>Cladding Spraying or Curtain Wall Aluminium Window Spraying</Title>
			<p>
				Most exterior cladding buildings are finished in polyurethane a hard
				wearing protection for the extreme weather conditions. <br />
				The most common colour used is Ral 9006 Silver, we specialise in
				repairing and the respraying of exterior cladding buildings, if you have
				the Ral code we have the finish for you. <br />
				<br />
				We work in the accordance with the health and safety rules and can offer
				guarantee subject to contract.
			</p>
		</Container>
		<StaticFooter />
	</div>
);

export default CladdingSpraying;



// WEBPACK FOOTER //
// ./src/components/page/cladding-spraying.js